export default {
  styleOverrides: {
    root: {
      marginLeft: -2,
    },
  },
};
